import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const LoadingMessage = declareStringWithPlaceholders(
  "Loader.loadingMessage",
  {
    text: ({ productName }) => `Opening ${productName} and loading your prompt`,
    placeholders: {
      productName:
        "the name of the product or service, like Copilot for Microsoft 365, Word, or Excel",
    },
    comment: `Description in a modal dialog telling customers that they are leaving Copilot Lab website to go to a different product or service."`,
  }
);

export const CancelButtonLabel = declareString("Loader.cancelButtonLabel", {
  text: "Cancel",
  comment: `Button text to cancel leaving Copilot Lab website to go to a different website, app, or product.`,
});

export const CopyButtonLabel = declareString("Loader.copyButtonLabel", {
  text: "Copy",
  comment: `Button text to copy prompt text into clipboard.`,
});

export const CopiedButtonLabel = declareString("Loader.copiedButtonLabel", {
  text: "Copied",
  comment: `Button text to tell user that prompt has been copied to clipboard.`,
});

export const CouldNotLoadPromptHeader = declareString(
  "Loader.couldNotLodPromptHeader",
  {
    text: "Couldn't load prompt",
    comment: `Header for modal dialog telling customers that the prompt could not be loaded.`,
  }
);

export const TryInAppByCopyHeader = declareStringWithPlaceholders(
  "Loader.tryInAppByCopyHeader",
  {
    text: ({ productName }) => `Try in ${productName}`,
    placeholders: {
      productName:
        "The name of the product or app a prompt should be tried in.",
    },
    comment: `Header for modal dialog telling customers that the prompt gets tried in a specific app.`,
  }
);

export const TryInAppByCopyMessage = declareStringWithPlaceholders(
  "Loader.tryInAppByCopyMessage",
  {
    text: ({ productName }) =>
      `Open ${productName}, then copy and paste the prompt into Copilot.`,
    placeholders: {
      productName:
        "The name of the product or app a prompt should be tried in.",
    },
    comment: `Message for modal dialog telling customers how to try the prompt in an app or service.`,
  }
);

export const CouldNotLoadPromptMessage = declareStringWithPlaceholders(
  "Loader.couldNotLoadPromptMessage",
  {
    text: ({ productName }) =>
      `Copy and paste the prompt into Copilot in ${productName}.`,
    placeholders: {
      productName:
        "The name of the product or app a prompt was attempted to be tried in.",
    },
    comment: `Message for modal dialog telling customers that the prompt could not be loaded.`,
  }
);
